import { createSlice } from "@reduxjs/toolkit";

interface AlertDialogState {
  isOpen: boolean;
  title?: string;
  desc?: string;
  btnName?: string;
  cancelName?: string;
  btnAction?: () => void;
  cancelAction?: () => void;
  img?: string;
  meta?: {
    hideTitle?: boolean;
    hideDesc?: boolean;
  };
  node?: {
    className?: string;
    contentClassName?: string;
    hideFooter?: boolean;
    node: React.ReactNode;
  };
  footerElementAttr?: {
    className?: string;
    order?: "first" | "last";
  };
  showImg?: boolean;
  customElement?: React.ReactNode;
  isLoading?: boolean;
}

const initialState: AlertDialogState = {
  isOpen: false,
};

export const alertDialogSlice = createSlice({
  name: "alertDialog",
  initialState,
  reducers: {
    showAlertDialog: (state, action) => {
      return {
        ...state,
        isOpen: true,
        title: action.payload.title,
        desc: action.payload.desc,
        btnName: action.payload.btnName,
        cancelName: action.payload.cancelName,
        btnAction: action.payload.btnAction,
        cancelAction: action.payload.cancelAction,
        img: action.payload.img,
        node: action.payload.node,
        footerElementAttr: action.payload.footerElementAttr,
        showImg: action.payload.showImg,
        meta: action.payload.meta,
        customElement: action.payload.customElement,
        isLoading: action.payload.isLoading,
      };
    },
    hideAlertDialog: (state) => {
      return {
        ...state,
        isOpen: false,
      };
    },
    setAlertDialogLoading: (state, action) => {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
  },
});

export const { showAlertDialog, hideAlertDialog, setAlertDialogLoading } =
  alertDialogSlice.actions;

export default alertDialogSlice.reducer;
